'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var CrmCreationSource = (0, _immutable.Record)({
  connectedObjectSourceId: null,
  name: null,
  objectTypeId: null
}, 'CrmCreationSource');

exports.default = CrmCreationSource;
module.exports = exports['default'];